import { Grid, Typography } from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';
import { TextInput } from '@ncr-retail/base-retail-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputField } from 'src/common/interfaces/InputField';
import { styles } from './form-input-view-styles';

interface FormInputViewProps {
  disabled: boolean;
  handleInputPayment: (event?) => void;
  handleInputChange: (event) => void;
  handleOnFocus: (event) => void;
  inputCollection: InputField[];
  dataTestId: string;
  containerClass?: string;
  maxLength?: number;
}
const FormInputView: React.FC<FormInputViewProps> = ({
  disabled,
  handleInputPayment,
  handleInputChange,
  handleOnFocus,
  inputCollection,
  dataTestId,
  containerClass,
  maxLength,
}): JSX.Element => {
  const classes = styles();

  const [disableInputs, setDisableInputs] = useState<boolean>(disabled);

  useEffect(() => {
    setDisableInputs(false);
  }, []);
  const { t } = useTranslation();
  const onManualEntryScreen = inputCollection?.find(input => input.id === 'manualEntry');
  return (
    <>
      {onManualEntryScreen && (
        <>
          <Grid item data-testid='form-title' className={classes.validationTitleGrid}>
            <Typography variant='h2'>{t('MicrValidationTitle')}</Typography>
          </Grid>
          <Grid item className={classes.validationDividerGrid}>
            <div data-testid='divider' className={classes.validationDivider}></div>
          </Grid>
        </>
      )}
      <Grid item data-testid='form-container'>
        <form
          className={classes.formBottomMargin}
          onSubmit={event => {
            event.preventDefault();
            handleInputPayment();
          }}
          data-testid={dataTestId}
        >
          {inputCollection &&
            inputCollection.map(
              (field, index): JSX.Element => {
                const {
                  dataTestIdPrefix = 'manual-amount-entry',
                  type = 'text',
                  value = '',
                  helperText = '',
                  name,
                  label,
                  ...rest
                } = field;
                const inputIcon = helperText ? { icon: <Warning /> } : undefined;
                const labelValue = t(label ?? '');

                return (
                  <div className={`${classes.field} ${containerClass}`} key={name}>
                    <TextInput
                      {...rest}
                      label={labelValue}
                      name={name}
                      type={type}
                      helperText={t(helperText)}
                      value={value}
                      onChange={handleInputChange}
                      disabled={disableInputs}
                      onFocus={handleOnFocus}
                      error={!!helperText}
                      autoComplete='off'
                      inputProps={{
                        'data-testid': `${dataTestIdPrefix}-input-field`,
                        'data-keyboard-owner': `${name}-focus`,
                        'data-id': index,
                        maxLength: maxLength,
                      }}
                      id={name}
                      inputIcon={inputIcon}
                    />
                  </div>
                );
              },
            )}
        </form>
      </Grid>
    </>
  );
};

export default FormInputView;
